export default __webpack_public_path__ + "static/media/ZOOM_OUT.f9a26aab.svg";